'use client';

import { useTheme, type Theme } from '@/lib/ThemeProvider';
import styles from './ThemeToggle.module.css';

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32 1.41-1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
    </svg>
  );
}

function SystemIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <rect x="3" y="5" width="18" height="12" rx="2" />
      <path d="M9 21h6m-3-4v4" />
    </svg>
  );
}

const THEME_ORDER: Theme[] = ['light', 'dark', 'system'];
const THEME_LABEL: Record<Theme, string> = {
  light: 'Светлая тема',
  dark: 'Тёмная тема',
  system: 'Системная тема',
};

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const current: Theme = theme;
  const resolved = resolvedTheme ?? 'light';
  const isDark = resolved === 'dark';
  const next = THEME_ORDER[(THEME_ORDER.indexOf(current) + 1) % THEME_ORDER.length];
  const label = `Тема: ${THEME_LABEL[current]} (применена ${
    isDark ? 'тёмная' : 'светлая'
  }). Переключить на: ${THEME_LABEL[next]}`;

  return (
    <button
      type="button"
      className={className ? `${styles.toggle} ${className}` : styles.toggle}
      onClick={() => setTheme(next)}
      aria-label={label}
      title={label}
    >
      {current === 'system' ? <SystemIcon /> : isDark ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}
